export type FilterType = 'reason' | 'processing_state' | 'value' | 'page' | 'evaluation';

/**
 * Convert frontend filter state to backend format
 */
export function formatFilters(
  frontendFilters: Record<string, unknown[]>
): Record<string, [FilterType, unknown[]]> {
  const backendFilters: Record<string, [FilterType, unknown[]]> = {};

  for (const [columnName, filterValues] of Object.entries(frontendFilters)) {
    if (filterValues.length > 0) {
      // Convert special frontend values to backend format
      const convertedValues = filterValues
        .map(value => {
          if (value === '__no_data__') {
            return null; // Special case for no data
          }
          return value;
        })
        .filter(value => value !== undefined);

      if (convertedValues.length > 0) {
        // Default to 'value' filter type, but you can extend this to support other types
        backendFilters[columnName] = ['value', convertedValues];
      }
    }
  }

  return backendFilters;
}
